import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocalAuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard {
  constructor(
    private authService: LocalAuthService,
    private router: Router
  ) { }

  canActivate(): boolean {
    if (this.authService.accessToken) {
      this.router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }

}
